import React, {useState, useContext} from 'react';
import styles from '../AuthForms.module.sass';
import cn from 'classnames';
import { useState } from 'react';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { ConquerContext } from '../../../contexts/ConquerContext';
import { AUTH_ZONE } from '..';
import Loader from '../../LoaderCircle';

const LoginForm = ({requestZoneChange, onFinishCallback}) => {

    const [showPassword, setShowPassword] = useState( false );
    
    const conquer = useContext( ConquerContext );

    const [username, setUsername] = useState( '' );
    const [password, setPassword] = useState( '' );
    const [error, setError] =  useState( '' );

    const [isLoading, setIsLoading] = useState( false );
    
    function showError( message ){
        
        setError( message );
        return false;
        
    }

    function checkFields(){

        if( !username || checkUsername(username) ) return showError( 'You have to provide a valid username' );
        if( !password || password.length < 8 || password.length > 16 ) return showError( 'You need to provide a valid password. Min 8 chars and max 16 chars' );

        setError('');

        return true;

    }

    function checkUsername( text ){
        const chars = '/@#$%^& ';
        for ( var z = 0; z<chars.length; z++ ) if( text.includes( chars.charAt(z) ) ) return true;
        return false;
    }

    async function tryToLogin(){

        if( !checkFields() ) return false;

        setIsLoading( true );
        let response = await conquer.Auth.get( { username, password, type: 'USERNAME' } );
        setIsLoading( false );

        if( response.error ) return showError( response.error );
        if( !response.username ) return showError( 'There was an error when trying to log you in. Please try again.' );

        onFinishCallback?.();

    }

    return (
        <div className={'form'}>
            <div className={styles.form__column}>
                <div className={'fields_container'}>
                    <input
                        type='text'
                        placeholder='Username'
                        className={error && !isLoading ? 'error' : ''}
                        onChange={(event) => {setUsername(event.target.value)}}
                    />
                    <div className={'input_container'}>
                        <input
                            type={showPassword ? 'text' : 'password'}
                            placeholder='Password'
                            className={error && !isLoading ? 'error' : ''}
                            onChange={(event) => {setPassword(event.target.value)}}
                        />
                        <button
                            onClick={() => {
                                setShowPassword(!showPassword);
                            }}
                            className={'input_icon'}>
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                        </button>
                    </div>
                </div>
                <div className={'form_bottom'}>
                    <button onClick={ () => { requestZoneChange( AUTH_ZONE.PASSWORD_RESET ) } } className={'helperLink'}> Forgot your password? </button>
                </div>
                { isLoading ? 
                    <Loader /> : 
                    <div className={'btn_container'}>
                        <button className={cn('button', 'secondary')} onClick={() => { requestZoneChange( AUTH_ZONE.REGISTER ) }}>
                            Register
                        </button>
                        <button className={cn('button', 'primary')} onClick={tryToLogin}>
                            Login
                        </button>
                    </div>
                }
                {error && <p className={'error'}>{error}</p>}
            </div>
        </div>
    );
};

export default LoginForm;
